import { FC, TextareaHTMLAttributes } from "react"
import { useField } from "formik"
import clsx from "clsx"
import { FlexBox } from "@components/wrapper"

export interface FormikTextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  errorText?: string
  maxCharacter?: number
  minCharacter?: number
  name: string
  inputClassName?: string
}

export const FormikTextArea: FC<FormikTextAreaProps> = ({
  placeholder,
  rows,
  minCharacter,
  maxCharacter,
  name,
  className,
  inputClassName,
  ...props
}) => {
  const [field, meta] = useField(name)
  const errorText = meta.error
  const val = field.value as string

  return (
    <div className={clsx("relative", className)}>
      <textarea
        rows={rows}
        {...field}
        {...props}
        className={clsx(
          inputClassName,
          "py-2.5 px-3 rounded w-full border-2 border-grey-ec lg:text-base",
          "focus:outline-none focus:shadow-outline focus:border-green active:shadow-outline active:border-green text-sm",
          field.value && !errorText && "border-2 !border-green",
          errorText && "!border-red border"
        )}
      />
      <FlexBox justify="between">
        <small className="counter">
          {minCharacter ? `Minimal ${minCharacter} Karakter` : `Maksimal ${maxCharacter} Karakter`}{" "}
          {maxCharacter ? ` (${val.length}/${maxCharacter})` : ` (${val.length} karakter)`}
        </small>

        <small className="text-red">{errorText}</small>
      </FlexBox>
    </div>
  )
}
